import { __decorate } from "tslib";
import { Component, EventEmitter, Output } from '@angular/core';
import { UtilityService } from "../../../services/utility.service";
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { SharedHttp } from "../../../services/http-client.service";
import { Router } from "@angular/router";
import { AuthService } from "../../../services/auth.service";
let MobileNumberValidationComponent = class MobileNumberValidationComponent {
    constructor(utility, sanitizer, themeService, httpClient, router, auth) {
        this.utility = utility;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.router = router;
        this.auth = auth;
        this.backColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.inputBackColor = '';
        this.accentColor = '';
        this.mobile = '';
        this.token = '';
        this.limitReached = false;
        this.phoneError = false;
        this.otpInvalid = false;
        this.otpInvalidErrorMessage = '';
        this.smsSent = false;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.mobileValidated = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
        });
        this.getUserData();
    }
    ngOnInit() {
    }
    fetchUser() {
        this.auth.fetchUser().then((data) => {
            this.user = JSON.parse(localStorage.getItem('user'));
            this.getUserData();
        });
    }
    getUserData() {
        this.mobile = this.user.mobile;
        this.maxMobileVerificationAttempts = this.user.max_mobile_verification_attempts;
        this.mobileVerificationAttempts = this.user.mobile_verification_attempts;
        if (this.mobileVerificationAttempts >= this.maxMobileVerificationAttempts) {
            this.limitReached = true;
        }
        if (this.mobileVerificationAttempts === this.maxMobileVerificationAttempts) {
            this.sendSms();
        }
    }
    sendSms() {
        this.phoneError = !this.utility.checkPhone(this.mobile);
        if (!this.phoneError) {
            this.utility.goDisableSendSmsButton();
            this.httpClient.post('user/sendmobilevalidationtoken', {
                mobile_number: this.mobile,
                timeout: this.utility.timeLeft
            }).subscribe((data) => {
                this.smsSent = true;
                this.fetchUser();
            }, (error) => {
                this.utility.resetTimer();
                this.fetchUser();
            });
        }
    }
    verifyOtp() {
        this.httpClient.post('user/checkmobilevalidationtoken', { token: this.token }).subscribe((data) => {
            this.otpInvalid = false;
            this.mobileValidated.emit(true);
        }, (error) => {
            this.otpInvalid = true;
            this.otpInvalidErrorMessage = error.error;
        });
    }
    goToContact(event) {
        if (event.target['tagName'] === 'SPAN') {
            this.router.navigateByUrl('/contact');
        }
    }
};
MobileNumberValidationComponent.ctorParameters = () => [
    { type: UtilityService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: SharedHttp },
    { type: Router },
    { type: AuthService }
];
__decorate([
    Output()
], MobileNumberValidationComponent.prototype, "mobileValidated", void 0);
MobileNumberValidationComponent = __decorate([
    Component({
        selector: 'ecd-mobile-number-validation',
        template: __importDefault(require("./mobile-number-validation.component.html")).default,
    })
], MobileNumberValidationComponent);
export { MobileNumberValidationComponent };
